import React, { useEffect } from "react";
import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import { Row, Col } from "react-bootstrap";
import TreeCustom from "../ReusableComp/TreeCustom";
import styles from "./CustomServiceMapping.module.css";
import Tree from "../ReusableComp/TreeCustomDataObjects";
import cloneDeep from "lodash-es/cloneDeep";
import { GetStateFromData } from "../../../components/CustomHooks/CustomHooks";

const CustomServiceMapping = (props) => {
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";

  const anchor = "right";

  const [stateOpen, setState] = React.useState(false);

  const [filter, setFilter] = React.useState("");

  const [stateForCustomServiceJson, setStateForCustomServiceJson] =
    React.useState();

  const [parentMapping, setparentMapping] = React.useState(false);
  const [childMapping, setchildMapping] = React.useState(false);

  const [parentChildCustom, setParentChildCustom] = React.useState("");

  const [showMapButtonState, setShowMapButtonState] = React.useState("");

  const [customServiceIds, setcustomServiceIds] = React.useState(new Set());

  useEffect(() => {
    if (props.state[props.index] && props.state[props.index]["OutputParams"]) {
      var mapEw = new Set();

      getAllMappedIds(props.state[props.index]["OutputParams"], mapEw);
      setcustomServiceIds(mapEw);
    }
  }, []);

  const contexts = GetStateFromData();
  const { dataObjectsContent } = contexts.contexts;

  console.log("dataObjectsContent===>>", dataObjectsContent);
  function getAllMappedIds(customizedScreenData, mapEw) {
    Object.keys(customizedScreenData).forEach((content1) => {
      if (
        Object.keys(customizedScreenData[content1]).length > 0 &&
        typeof customizedScreenData[content1] === "object"
      ) {
        getAllMappedIds(customizedScreenData[content1], mapEw);
      } else {
        if (customizedScreenData[content1].length > 0) {
          mapEw.add(customizedScreenData[content1]);
        }
      }
      //
    });
  }
  var prevJson =
    props.defaultState !== undefined
      ? props.defaultState[props.index]?.OutputParams
      : props?.currentState?.OutputParams;

  function cancelHandler() {
    props.setStateMapping(false);
  }

  function saveButton() {
    const temp = props.state;
    temp[props.index]["OutputParams"] = cloneDeep(props.stateJsonBeforeSaving);
    props.setState(temp);
    props.setStateMapping(false);
  }

  useEffect(() => {
    setState(props.stateOpen);
  }, [props.stateOpen]);

  const { t } = useTranslation(["styles", "translation"]);

  const useStyles = makeStyles({
    root: {
      "& .MuiDrawer-root": {},
      "& .MuiBackdrop-root": {
        opacity: "1 !important",
      },
      "& .MuiDrawer-paperAnchorRight": {
        // width:641,
        width: 741,
        right: t("styles:leftVal"),
        left: t("styles:rightVal"),
        overflowY: "unset",
      },
    },
    list: {
      width: 250,
    },
    fullList: {
      width: "auto",
    },
    headingMapping: {
      color: "#000000",
      marginLeft:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? null
          : "15px",
      marginRight:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "15px"
          : null,
      marginTop: "15px",
    },
    headingMappingContent: {
      fontWeight: "bold",
    },
    columnFirst: {
      width: "321px",
      border: "1px solid #F0F0F0",
      opacity: 1,
      height: "100%",
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    columnSecond: {
      width: "421px",
      border: "1px solid #F0F0F0",
      opacity: 1,
      height: "100%",
      paddingLeft: "0px",
      paddingRight: "0px",
    },
    allColumns: {
      width: "742px",
      height: "100%",
      marginTop: "10px",
      margin: "0px",
    },
    columnUpperHeading: {
      height: "32px",
      width: "321px",
      backgroundColor: "#F5F5F5",
      border: "1px solid #F0F0F0",
      opacity: "1",
      paddingLeft:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? null
          : "8px",
      paddingRight:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "8px"
          : null,
      paddingTop: "6px",
    },
    columnUpperHeadingSecond: {
      height: "32px",
      width: "421px",
      backgroundColor: "#F5F5F5",
      border: "1px solid #F0F0F0",
      opacity: "1",
      paddingLeft:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? null
          : "8px",
      paddingRight:
        window?.psh_configs?.selectedLanguage === "ar" ||
        window?.psh_configs?.selectedLanguage === "ar-SA"
          ? "8px"
          : null,
      paddingTop: "6px",
    },
    contentHeading: {
      font: "normal normal 600 12px/13px Open Sans",
      color: "#000000",
    },
    searchBar: {
      // width:"310px"
    },
  });

  function toggleDrawer() {
    props.setStateMapping(false);
  }

  const [searchWord, setsearchWord] = React.useState("");

  const [searching, setSearching] = React.useState(false);

  const [selectedMappedValue, setSelectedMappedValue] = React.useState("");

  const classes = useStyles();

  return (
    <Drawer
      className={classes.root + " " + "formBuilder_main_app"}
      anchor={anchor}
      open={stateOpen}
      onClose={() => toggleDrawer()}
      style={{ direction: translationStyles1 ? "rtl" : "ltr" }}
    >
      <div
        className={styles.headingMapping}
        style={
          translationStyles1 ? { marginLeft: null, marginRight: "15px" } : null
        }
      >
        <span className={styles.headingMappingContent}>
          {t("translation:Output Parameter Mapping")}
        </span>
      </div>

      <Row
        className={styles.allColumns}
        style={translationStyles1 ? { marginRight: "unset" } : null}
      >
        <>
          <Col className={styles.columnFirst}>
            <div
              className={styles.columnUpperHeading}
              style={
                translationStyles1
                  ? { paddingLeft: "unset", paddingRight: "8px" }
                  : null
              }
            >
              <span className={styles.contentHeading}>
                {t("translation:Select the Variables you want to map")}
              </span>
            </div>

            <Tree
              data={dataObjectsContent}
              selectedMappedValue={selectedMappedValue}
              setSelectedMappedValue={setSelectedMappedValue}
              setParentChildCustom={setParentChildCustom}
              customServiceIds={customServiceIds}
              setcustomServiceIds={setcustomServiceIds}
            />
          </Col>
        </>

        <div className={styles.columnSecond}>
          <div
            className={styles.columnUpperHeadingSecond}
            style={
              translationStyles1
                ? { paddingLeft: "unset", paddingRight: "8px" }
                : null
            }
          >
            <span className={styles.contentHeading}>
              {" "}
              {t("translation:Select the Variables you want to map")}
            </span>
          </div>

          <TreeCustom
            containerId={props.containerId}
            key={Math.random() * 10}
            data={props.stateJsonBeforeSaving}
            samplejson={props.stateJsonBeforeSaving}
            selectedMappedValue={selectedMappedValue}
            setSelectedMappedValue={setSelectedMappedValue}
            parentChildCustom={parentChildCustom}
            setParentChildCustom={setParentChildCustom}
            saveInJson={props.saveInJson}
            stateForCustomServiceJson={stateForCustomServiceJson}
            setStateForCustomServiceJson={setStateForCustomServiceJson}
            isfirst={true}
            filter={filter}
            ischeckbox={true}
            parentMapping={parentMapping}
            childMapping={childMapping}
            setparentMapping={setparentMapping}
            setchildMapping={setchildMapping}
            searching={searching}
            searchWord={searchWord}
            showMapButtonState={showMapButtonState}
            setShowMapButtonState={setShowMapButtonState}
            customServiceIds={customServiceIds}
            setcustomServiceIds={setcustomServiceIds}
          />
        </div>
      </Row>

      <footer
        style={{
          width: "100%",
          height: "50px",
          color: "gray",
          position: "fixed",
          bottom: 0,
          boxShadow: "0px 1px 10px grey",
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            paddingTop: "11px",
            position: "inherit",
            left: translationStyles1 ? "15px" : null,
            right: translationStyles1 ? null : "15px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined`}
            variant="outlined"
            style={{ width: "54px", height: "28px", fontSize: "12px" }}
            onClick={() => cancelHandler()}
          >
            {t("translation:Cancel")}
          </Button>
          <Button
            disableFocusRipple
            disableRipple
            tabIndex={0}
            className={`formBuilder-MuiButton-outlined`}
            variant="contained"
            style={{
              backgroundColor: "#0072c6",
              color: "white",
              width: "63px !important",
              height: "28px",
              fontSize: "12px",
              marginLeft: "12px",
            }}
            onClick={() => saveButton()}
          >
            {t("translation:Save & Exit")}
          </Button>
        </div>
      </footer>
    </Drawer>
  );
};

export default CustomServiceMapping;
